import * as React from "react";
const SvgFlag = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6Z",
  fill: "currentColor"
}));
export default SvgFlag;